import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { qualidadeSchema } from './qualidade-schemas';

// Qualidade & evals da frota (admin) — scores do judge, evaluators e goldset.
export function useQualidade() {
  return useQuery({
    queryKey: ['agentes', 'qualidade'] as const,
    queryFn: ({ signal }) => api('/api/v2/agentes/qualidade', { schema: qualidadeSchema, signal }),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
